import { createEvent } from 'effector';

export const setPayinNewOrdersCount = createEvent<number>();
